import React from "react"
import "./_note.scss"
import UniversalLink from "§/src/utils/UniversalLink"
// Atoms
import ButtonArrow from "§/src/components/atoms/buttons/button-arrow"
import { GatsbyImage } from "gatsby-plugin-image"
// Language
import { useTranslation } from 'react-i18next'

const Note = ({ note, layouter, ...props }) => {
  const { t } = useTranslation()

  // Verifica se note esiste
  if (!note) {
    return null
  }

  const atomClassName = "note"
  const atomClass =
    props?.className !== undefined
      ? atomClassName + " " + props?.className
      : atomClassName

  // Accesso sicuro alle proprietà
  const noteImage = note?.featuredImage?.node?.gatsbyImage || note?.image?.gatsbyImage
  const noteImageAlt = note?.featuredImage?.node?.altText || note?.image?.altText || ""
  const applicationLabel = !!layouter
  const noteTitle = note?.title || note?.quote?.title
  const noteSubTitle = note?.cptApplicationChildrens?.subtitle || note?.quote?.subtitle || note?.quote?.title

  // Accesso sicuro alle proprietà dell'array note?.quote?.cta
  const hasCta = note?.uri || (note?.quote?.cta && note?.quote?.cta.length > 1)
  const noteLink = note?.uri || (note?.quote?.cta && note?.quote?.cta[1])
  const ctaText = note?.quote?.cta && note?.quote?.cta.length > 2 ? note?.quote?.cta[2] : t('Leggi')

  const noteQuote = note?.quote?.quote
  const noteSignature = note?.quote?.signature

  return (
    <div comp={atomClassName} className={atomClass + ' d-flex flex-wrap flex-column-reverse flex-lg-row'}>
      <div className="left inner d-flex flex-column justify-content-center position-relative">
        {!applicationLabel &&
          <p className="fs-12 text-uppercase mb-0">
            {t('Note applicative')}
          </p>
        }
        {noteTitle &&
          <p className="title h3 mb-2">{noteTitle}</p>
        }
        {noteSubTitle &&
          <p className="subtitle h7 mb-0">{noteSubTitle}</p>
        }
        {noteQuote &&
          <p className="quote h4 mb-0">{noteQuote}</p>
        }
        {noteSignature &&
          <p className="signature h7 mb-0 mt-3">{noteSignature}</p>
        }
        {hasCta &&
          <div className={"flex justify-content-start pt-4"}>
            <UniversalLink
              text={ctaText}
              className="link-button"
              to={noteLink}
            >
              <ButtonArrow
                dir="end"
                text={ctaText}
                className={
                  "button-arrow btn btn-link cta stretched-link mt-5 mt-md-0 stretched-link"
                }
              />
            </UniversalLink>
          </div>
        }
      </div>
      {noteImage && (
        <GatsbyImage
          className="image-rounded right"
          image={noteImage}
          objectFit="cover"
          alt={noteImageAlt}
        />
      )}
    </div>
  )
}

export default Note
